import { render, staticRenderFns } from "./AirFreight.vue?vue&type=template&id=193e6607&scoped=true&"
var script = {}
import style0 from "./AirFreight.vue?vue&type=style&index=0&id=193e6607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e6607",
  null
  
)

export default component.exports